function httpRequest (url, data, options) {
    options = Object.assign({httpMethod: 'POST'}, options);
    return new Promise(function (resolve, reject) {
        const req = new XMLHttpRequest(); // eslint-disable-line no-undef
        req.open(options.httpMethod, url);
        req.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        req.onload = function () {
            if (req.status === 200) {
                let obj = JSON.parse(req.response) || {};
                if (obj.d) { obj = obj.d; }
                resolve(obj);
            } else {
                if (req.status >= 500 || !req.response) {
                    reject({ Success: false, Errors: [{ Type: 'CallWebService:Server', Message: req }] });
                } else {
                    try {
                        const obj = JSON.parse(req.response);
                        if (obj) {
                            reject({ Success: false, Errors: [{ Type: 'CallWebService:App', Message: obj }] });
                        } else {
                            reject({ Success: false, Errors: [{ Type: 'CallWebService:Server', Message: req }] });
                        }
                    } catch (e) {
                        reject({ Success: false, Errors: [{ Type: 'CallWebService:Server', Message: req }] });
                    }
                }
            }
        };
        req.onerror = function () {
            reject({ Success: false, Errors: [{ Type: 'CallWebService:XHR', Message: req }] });
        };

        req.send(data ? JSON.stringify(data) : null);
    });
}

function versionFilter (minVersion, maxVersion) {
    return function (e) {
        if (!minVersion && !maxVersion) { return true; }
        if (minVersion && e.Version < minVersion) { return false; }
        if (maxVersion && e.Version > maxVersion) { return false; }
        return true;
    };
}

let sdInstance;
const proto = function (rootUrl, deployment, environment, preseed, debug) {
    if (sdInstance) {
        throw new Error('Do not try to create more than one serviceDiscovery instance!');
    }
    sdInstance = this;
    this.__registry = this.RegistryUrl = rootUrl;
    this.__deployment = deployment;
    this.__environment = environment;
    this.__cacheKey = 'FB.Discovery.Cache-' + environment + '-' + deployment;
    this.__patches = {};
    this.__debug = debug || function () {};
    this.__hits = 0;
    this.__misses = 0;

    let storedCache = null;
    try {
        storedCache = JSON.parse(localStorage.getItem(this.__cacheKey));
    } catch (e) {
    }

    this.__debug('init', 'Fetching last update');
    this.__cache = httpRequest(this.__registry + 'last-update', null, { httpMethod: 'GET' })
        .then((lastUpdate) => {
            if (!storedCache || !storedCache.LastUpdate || Number(storedCache.LastUpdate)<(new Date(lastUpdate)).getTime()) {
                this.__debug('init', 'Cache is not valid, purging');
                return {
                    LastUpdate: (new Date()).getTime(),
                    Endpoints: {},
                    Request: {}
                };
            }
            return storedCache;
        }).then(cache => {
            const requestPromises = {};
            let loaded = 0;
            if (cache.Request) {
                for (const k in cache.Request) {
                    if (cache.Request.hasOwnProperty(k)) {
                        requestPromises[k] = Promise.resolve(cache.Request[k]);
                        loaded++;
                    }
                }
            }
            this.__debug('init', 'Loaded ' + loaded + ' items from localStorage cache');
            loaded = 0;
            if (preseed) {
                for (const k in preseed) {
                    if (!preseed.hasOwnProperty(k)) { continue; }
                    requestPromises[k] = Promise.resolve(preseed[k]);
                    loaded++;
                }
                this.__debug('init', 'Loaded ' + loaded + ' items from preseed');
            }
            const allPromises = [];
            for (const j in requestPromises) {
                if (requestPromises.hasOwnProperty(j)) { allPromises.push(requestPromises[j]); }
            }
            return Promise.all(allPromises).then(allItems => {
                for (let i = 0; i < allItems.length; i++) {
                    for (const subsystem in allItems[i]) {
                        if (!allItems[i].hasOwnProperty(subsystem)) { continue; }
                        for (const service in allItems[i][subsystem]) {
                            if (!allItems[i][subsystem].hasOwnProperty(service)) { continue; }
                            cache.Endpoints[subsystem + '/' + service] = allItems[i][subsystem][service];
                        }
                    }
                }
                this.__debug('init', 'Cache initialized, contains ' + Object.keys(requestPromises).length + ' response promises, ' + Object.keys(cache.Request || {}).length + ' response records, ' + Object.keys(cache.Endpoints || {}).length + ' endpoint records');
                return [cache, requestPromises];
            });
        });

    this.__fetch = function (c, key, subsystem, service) {
        let request = null;
        if (!subsystem && !service) { throw new Error('Internal error: fetching both without subsystem and service.'); }
        if (!subsystem) {
            request = {
                '$type': 'FB.Interface.Discovery.TypedServiceRequest, FB.Interface.Discovery',
                'Service': service,
                'ExcludeInfrastructureSubsystem': false,
                'ParentAuditEvent': null
            };
        } else if (!service) {
            request = {
                '$type': 'FB.Interface.Discovery.SubsystemServiceRequest, FB.Interface.Discovery',
                'Subsystem': service,
                'ParentAuditEvent': null
            };
        } else {
            if (c[0].Endpoints[subsystem + '/' + service]) {
                this.__hits++;
                this.__debug('cache', 'Endpoint cache hit for ' + subsystem + '/' + service);
                return Promise.resolve({[subsystem]: {[service]: c[0].Endpoints[subsystem + '/' + service]}});
            }
            request = {
                '$type': 'FB.Interface.Discovery.ExactServiceRequest, FB.Interface.Discovery',
                'Service': service,
                'Subsystem': subsystem,
                'ParentAuditEvent': null
            };
        }
        this.__misses++;
        this.__debug('core', 'Fetching ' + subsystem + '/' + service);
        return httpRequest(this.__registry + 'service/search', {
            CustomDeployment: this.__deployment,
            Services: [request]
        }).then(data => {
            const rv = {};
            this.__debug('core', 'Got response for ' + subsystem + '/' + service);
            if (!data.Responses || !data.Responses.length) { return rv; }

            data.Responses[0].Services.forEach(service => {
                service.Endpoints.forEach(endpoint => {
                    endpoint.Subsystem = service.Subsystem;
                    endpoint.Service = service.Service;
                });
                (rv[service.Subsystem] || (rv[service.Subsystem] = {}))[service.Service] = service.Endpoints;
                this.__debug('cache', 'Endpoint saved ' + service.Subsystem + '/' + service.Service);
                c[0].Endpoints[service.Subsystem + '/' + service.Service] = service.Endpoints;
            });
            this.__debug('cache', 'Response saved ' + subsystem + '/' + service + ' = ' + JSON.stringify(rv));
            c[0].Request[key] = rv;
            try {
                localStorage.setItem(this.__cacheKey, JSON.stringify(c[0]));
                this.__debug('cache', 'localStorage cache updated');
            } catch (e) {
                this.__debug('cache', 'Unable to update localStorage cache');
            }
            return rv;
        });
    };

    this.PatchAuthority = function (src,dst) {
        this.__patches[src] = dst;
    };

    this.Url = function (endpoint) {
        let rv = 'http';
        if (endpoint.Security.indexOf('?Ssl') !== -1 || endpoint.Security.indexOf('+Ssl') !== -1) { rv += 's'; }
        rv += '://';
        rv += endpoint.ThinClientHost || endpoint.Host;
        if (this.__patches[rv]) {
            rv = this.__patches[rv];
        }
        rv += '/';
        if (endpoint.ThinClientPath) {
            rv += endpoint.ThinClientPath.replace(/^\/*/,'');;
        } else if (endpoint.Path) {
            rv += endpoint.Path.replace(/^\/*/,'');;
        }
        return rv;
    };

    this.UrlWithSubsystem = function (endpoint) {
        return [endpoint.Subsystem, this.Url(endpoint)];
    };

    this.Authority = function (endpoint, forceSsl) {
        if (!endpoint) {
            return '';
        }
        let rv = 'http';
        if (forceSsl || endpoint.Security.indexOf('?Ssl') !== -1 || endpoint.Security.indexOf('+Ssl') !== -1) {
            rv += 's';
        }
        rv += '://';
        rv += endpoint.Host;
        if (this.__patches[rv]) {
            rv = this.__patches[rv];
        }
        rv += '/';
        return rv;
    };

    this.GetApisRaw = function (service) {
        const key = '/' + service;
        return this.__cache.then(c => {
            if (c[1][key]) {
                this.__debug('cache', 'Response cache hit ' + key);
                return c[1][key];
            } else {
                return (c[1][key] = this.__fetch(c, key, null, service));
            }
        });
    };

    this.GetApis = function (service, minVersion, maxVersion) {
        return this.GetApisRaw(service, minVersion, maxVersion).then((subsystems) => {
            const rv = {};
            const filter = versionFilter(minVersion, maxVersion);
            for (const subsystemName in subsystems) {
                if (!subsystems.hasOwnProperty(subsystemName)) { continue; }
                for (const svc in subsystems[subsystemName]) {
                    if (!subsystems[subsystemName].hasOwnProperty(svc)) { continue; }
                    let hasAnyVersioned = false;
                    subsystems[subsystemName][svc].forEach(endpoint => { hasAnyVersioned |= !!endpoint.Version; });
                    subsystems[subsystemName][svc].forEach(endpoint => {
                        if (!hasAnyVersioned || filter(endpoint)) {
                            rv[subsystemName] = this.Url(endpoint);
                        }
                    });
                }
            }
            return rv;
        });
    };

    this.GetApiRaw = function (subsystem, service) {
        const key = subsystem + '/' + service;
        return this.__cache.then(c => {
            if (c[1][key]) {
                this.__debug('cache', 'Response cache hit ' + key);
                return c[1][key];
            } else {
                return (c[1][key] = this.__fetch(c, key, subsystem, service));
            }
        }).then(subsystems => {
            return subsystems[subsystem][service];
        });
    };

    this.GetApi = function (subsystem, service, minVersion, maxVersion) {
        return this.GetApiRaw(subsystem, service).then((endpoints) => {
            let hasAnyVersioned = false;
            if (!endpoints) {
                return null;
            }
            endpoints.forEach(endpoint => { hasAnyVersioned |= !!endpoint.Version; });
            const filter = versionFilter(minVersion, maxVersion);
            for (let i = 0; i < endpoints.length; i++) {
                if (!hasAnyVersioned || filter(endpoints[i])) {
                    return this.Url(endpoints[i]);
                }
            }
            return null;
        });
    };
};
proto.instance = function () {
    return sdInstance;
};
module.exports = proto;
